import {
  Provider as ThemeProvider,
  teamsV2Theme,
} from "@fluentui/react-northstar";
import { BrowserRouter } from "react-router-dom";
import { Suspense, useEffect } from "react";
import {
  SessionContextProvider,
  TelemetryContextProvider,
} from "@smb/web-telemetry";

import { AppLaunchErrorBoundary } from "../components/errors/app-launch-error-boundary";
import { AuthProvider } from "../components/auth";
import { RegionalApolloProvider } from "../apollo/regional-apollo-provider";
import { AppLoader } from "../components/app-loader";
import { isInIframe } from "../utils/validators/isInIframe";
import { isInPowerChart } from "../utils/validators/isInPoweChart";
import { InstrumentationKeyProvider } from "../components/telemetry/InstrumentationKeyProvider";
import { updateLoggerContext } from "../utils/telemetry/updateLoggerContext";
import { isProdEnv } from "../utils/getEnvironment";

import { appStyles } from "./App.styles";
import { RouteSwitcher } from "./RouteSwitcher";

export function App() {
  useEffect(() => {
    updateLoggerContext();
  }, []);

  // Render the app only when it's loaded in the Iframe and inside PowerChart context.
  if (isProdEnv() && !isInIframe() && !isInPowerChart()) {
    return null;
  }

  return (
    <AuthProvider>
      <BrowserRouter>
        <TelemetryContextProvider>
          <SessionContextProvider>
            <RegionalApolloProvider>
              <InstrumentationKeyProvider>
                <ThemeProvider
                  theme={teamsV2Theme}
                  styles={appStyles}
                  as="main"
                >
                  <Suspense fallback={<AppLoader />}>
                    <AppLaunchErrorBoundary>
                      <RouteSwitcher />
                    </AppLaunchErrorBoundary>
                  </Suspense>
                </ThemeProvider>
              </InstrumentationKeyProvider>
            </RegionalApolloProvider>
          </SessionContextProvider>
        </TelemetryContextProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
